import { DEFAULT_LANGUAGE, LocalizedText } from 'apollo/localizedTypes';
import clearEmptyRichText from './clearEmptyRichText';
import isEmptyRichText from './isEmptyRichText';

const translatableRichText = (value?: LocalizedText | null): LocalizedText[] =>
  value && !isEmptyRichText(value[DEFAULT_LANGUAGE]) ? [clearEmptyRichText(value)] : [];

export default translatableRichText;
